import { render, staticRenderFns } from "./LoactionIsClosedModal.vue?vue&type=template&id=2c310c7e"
import script from "./LoactionIsClosedModal.vue?vue&type=script&lang=js"
export * from "./LoactionIsClosedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports